import { useParams } from 'react-router-dom'
import { useVersioning } from 'modules/versioning'

import { RouteParams } from 'constants/routes'

export const useGetIdentifiers = () => {
  const { shareID } = useParams<RouteParams<'SHARE_VIEW'>>()
  const { versionShortId } = useVersioning()

  return {
    shareIdentifier: shareID,
    versionShortId,
  }
}
